var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiamondGradient = function SvgIconDiamondGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_diamond_gradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_diamond_gradient_svg__b)",
    fillRule: "evenodd",
    d: "M4.9 4.634c.227-.275.565-.435.922-.435H18.27c.357 0 .695.16.923.435l3.332 4.478a1.2 1.2 0 0 1-.055 1.593l-9.56 9.922a1.2 1.2 0 0 1-.867.372c-.316 0-.631-.124-.867-.372L1.53 10.705a1.2 1.2 0 0 1-.056-1.592zM6.103 6 4.2 9h3.9l.857-3zm4.716 0L9.9 9h4.2l-.9-3zm4.316 0 .763 3h3.9l-1.812-3zm4.663 4.8h-3.9l-2.1 6.6zM12 17.4l2.1-6.6H9.9zm-3.9-6.6 2.1 6.6-6-6.6z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_diamond_gradient_svg__b",
    x1: 19.192,
    x2: 4.899,
    y1: 9.112,
    y2: 9.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53FFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_diamond_gradient_svg__a",
    width: 28,
    height: 24,
    x: -2,
    y: 0.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0745098 0 0 0 0 0.105882 0 0 0 0 0.14902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2599_56553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2599_56553",
    result: "shape"
  })))));
};
export default SvgIconDiamondGradient;